<template>
  <div
    class="landmarkLocation"
    v-on="$listeners"
    :class="{ landmarkLocation__selected: isPicked }"
  >
    <h4 class="col-md-2 landmarkLocation__title">
      <input
        class="landmarkLocation__radio"
        type="radio"
        name="address"
        :checked="isPicked"
        @change="$emit('click')"
      />
      自訂地標:
    </h4>
    <input
      type="text"
      class="landmarkLocation__inputField col-md-2"
      v-model="keywordFindLandmark"
      @change="searchLandmark()"
    />
    <div class="col-md-5">
      <select
        class="landmarkLocation__select"
        v-model="landmark"
        @change="selectLandmark(landmark)"
      >
        <option disabled :value="-1">請選擇</option>
        <option
          v-for="(mark, index) in landmarkList"
          :key="index"
          :value="index"
        >
          {{ mark.name + '=' + mark.address }}
        </option>
      </select>
    </div>
    <input
      type="text"
      required="required"
      class="landmarkLocation__inputField col-md-2"
      placeholder=""
      v-model="landmarkAddress"
    />
  </div>
</template>

<script>
import API from '@/assets/js/libs/API'
export default {
  props: {
    isPicked: Boolean,
  },
  data() {
    return {
      landmark: '',
      landmarkList: [],
      landmarkAddress: '',
      keywordFindLandmark: '',
    }
  },
  methods: {
    selectLandmark(value) {
      var value = {
        name: this.landmarkList[value].name,
        latitude: this.landmarkList[value].addressGPS.coordinates[1],
        longitude: this.landmarkList[value].addressGPS.coordinates[0],
        address: this.landmarkList[value].address,
      }
      this.landmarkAddress = value.address

      this.$emit('update-location', value)
    },
    searchLandmark() {
      this.landmarkList = []

      API.get(
        `landmark/gethailinglist/?key=${this.keywordFindLandmark.replace(
          /[ ]/g,
          '+',
        )}&isSupportOffice=false`,
      )
        .then((res) => {
          if (res.result === 'err') {
          } else {
            this.landmarkList = res.result.landmarkInfo
          }
          this.landmark = -1
        })
        .catch((err) => {
          console.log('searchLandmark', err)
        })
    },
    resetState() {
      this.landmarkList = []
      this.landmarkAddress = ''
      this.keywordFindLandmark = ''
    },
  },
}
</script>
<style lang="scss" scoped>
.landmarkLocation {
  &__selected {
    background-color: #ffffb3;
  }

  &__title {
    font-size: 18px;
    color: black;
    margin: 0;
    margin-left: 15px;
    height: 36px;
    line-height: 36px;
    max-width: 247.15px;
  }

  &__radio {
    margin: 0;
    height: 36px;
    vertical-align: top;
  }

  &__countySelect {
    height: 36px;
  }

  &__inputField {
    margin-left: 10px;
    height: 36px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  &__select {
    width: 100%;
    height: 36px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/mixins/PhoneHail/LandmarkLocation.vue